import { render, staticRenderFns } from "./ElaryWarningBox.vue?vue&type=template&id=724b3876&scoped=true&"
import script from "./ElaryWarningBox.vue?vue&type=script&lang=js&"
export * from "./ElaryWarningBox.vue?vue&type=script&lang=js&"
import style0 from "./ElaryWarningBox.vue?vue&type=style&index=0&id=724b3876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b3876",
  null
  
)

export default component.exports